import express, { Router } from 'express';
import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { validateMiddleware } from '@/shared/utils/middlewares';
import * as analyticsValidation from './analytics.validation';
import { getCaptureLeadsOverview, getCaptureLeadsPlatformTimeseries } from './analytics.controller';

const router: Router = express.Router();

router.get(
  '/capture-leads/overview',
  userAuthAndCheckPermissions(),
  validateMiddleware(analyticsValidation.getOverview),
  getCaptureLeadsOverview,
);

router.get(
  '/capture-leads/platform-timeseries',
  userAuthAndCheckPermissions(),
  validateMiddleware(analyticsValidation.getPlatformTimeseries),
  getCaptureLeadsPlatformTimeseries,
);

export default router;
